import React, {useEffect, useMemo, useState} from "react";
import {
  Chart as ChartJS,
  PointElement,
  LinearScale,
  TimeScale,
  Tooltip,
  Title,
} from "chart.js";
import "chartjs-adapter-date-fns";

import {LoadingView} from "../../../../designSystem/components/LoadingView";
import {OptionButton} from "../../../../designSystem/components/OptionButton";
import {Dialog} from "../../../../designSystem/components/Dialog";

import { MeasurementVisualizationModalContent} from "../MeasurementVisualizationModalContent";
import {MeasurementChart} from "../../../../components/MeasurementChart";
import {MeasurementTable} from "../../../../components/MeasurementTable";

import { METRICS } from "../../../../utils/constants";
import {filterMeasurementsByMetric} from "../../model/filterMeasurementsByMetric";
import {useMeasurementVisualization} from "../../hooks/useMeasurementVisualization";
ChartJS.register(PointElement, LinearScale, TimeScale, Tooltip, Title);

export const MeasurementVisualizationFeature = ({ defaultSelectedMetric }) => {
  const [selectedMetric, setSelectedMetric] = useState<string>(METRICS[0].key);
  const {
    loading,
    measurements,
    modalContent,
    onRequestDeleteMeasurement,
    onConfirmDeleteMeasurement,
    onConfirmSuccess
  } = useMeasurementVisualization()

  const onPressMetric = (metricKey: string) => {
    setSelectedMetric(metricKey);
  };

  useEffect(() => {
    setSelectedMetric(defaultSelectedMetric)
  }, [defaultSelectedMetric])

  const filteredMeasurements = useMemo(() => {
    return filterMeasurementsByMetric({ measurements, metric: selectedMetric });
  }, [selectedMetric, measurements])

  return (
    <React.Fragment>
      {!loading ?
        <div>
          <div className="flex flex-row gap-2 overflow-x-auto flex-nowrap pb-4 px-2">
            {METRICS.map((metric) => (
              <OptionButton
                key={metric.key}
                label={metric.label}
                isSelected={selectedMetric === metric.key}
                onClick={() => onPressMetric(metric.key)}
                icon={metric.icon}
              />
            ))}
          </div>

          {filteredMeasurements?.length > 0 ? (
            <>
              <MeasurementChart
                measurements={filteredMeasurements}
                metricType={selectedMetric}
              />
              <div className="px-2 pb-2">
                <MeasurementTable
                  editable
                  measurements={filteredMeasurements}
                  metricType={selectedMetric}
                  onClickDelete={onRequestDeleteMeasurement}
                />
              </div>
            </>
          ) : (
            <div className="text-center pt-4 text-gray-600">
              暫無錄得數據
            </div>
          )}
        </div>
        : <LoadingView/>
      }

      <Dialog isOpen={modalContent !== ''}>
        {MeasurementVisualizationModalContent({
          onConfirmDeleteMeasurement,
          onCloseDialog: onConfirmSuccess,
        })[modalContent] || <></>}
      </Dialog>
    </React.Fragment>
  );
};
